module.exports = __webpack_public_path__ + "static/media/reset_password_mail_sent.711bf1a6.png";